import { render, staticRenderFns } from "./NavigateToIcon.vue?vue&type=template&id=19870bb8&"
import script from "./NavigateToIcon.vue?vue&type=script&lang=js&"
export * from "./NavigateToIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports